import PropTypes from 'prop-types';
import React from 'react';

import { localPreferences } from 'app-components/utils/core';

import { BugsnagErrorBoundary } from 'utils/core/bugsnag';

import FallbackComponent from './FallbackComponent';
import LocalErrorBoundary from './LocalErrorBoundary';

const ErrorBoundary = (props) => {
  const { children, ...otherProps } = props;
  const disableBugsnag = localPreferences.getDisableBugsnag();
  const ErrorBoundarySelected = disableBugsnag ? LocalErrorBoundary : BugsnagErrorBoundary;
  return (
    <ErrorBoundarySelected FallbackComponent={FallbackComponent} {...otherProps}>
      {children || null}
    </ErrorBoundarySelected>
  );
};

ErrorBoundary.propTypes = {
  children: PropTypes.any,
};

ErrorBoundary.whyDidYouRender = false;

export default ErrorBoundary;
